import * as React from 'react';
import { useCallback } from 'react';

import { useTagInputHandlers } from '../../../../hooks/tagCloudTargeting';
import { DictionaryItem } from '../../../../typings/common';
import { TagEditorProps } from '../../../../typings/tagCloudTargeting';
import { TagSuggestDecorator } from '../../TagSuggestDecorator/TagSuggestDecorator';

export interface TagSuggestEditorProps extends TagEditorProps {
    suggestItems: DictionaryItem[];
}

export const TagSuggestEditor: React.FC<TagSuggestEditorProps> = React.memo(props => {
    const { suggestItems, onRefChange, onFocus, onSubmit } = props;

    const { onKeyDown, onBlur, onPaste, value, onChange } = useTagInputHandlers(props);

    const onSelect = useCallback(
        (item: DictionaryItem) => {
            onSubmit([item.text]);
        },
        [onSubmit]
    );

    return (
        <TagSuggestDecorator
            text={value}
            suggestItems={suggestItems}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onFocus={onFocus}
            onBlur={onBlur}
            onPaste={onPaste}
            onSelect={onSelect}
            onRefChange={onRefChange}
        />
    );
});
